export default __webpack_public_path__ + "static/media/storageUnit1-afterC-1440w.69e16052.avif";